module.exports = __webpack_public_path__ + "static/twitch-09e614e7237238b3b2b363d349e7b62b.svg";